import InputField from "components/controls/InputField";
import { IRowItem } from "library/types";

type Props = {
  item: IRowItem;
};

export function CarrierCell({ item }: Props) {
  const handleTableUpdate = (value) => {
    if (value || value === "") {
      const updatedItem = {
        ...item,
        carrierName: value,
        isEdited: true,
      };
      item.updateState(updatedItem);
    }
  };
  return (
    <InputField
      label=""
      name="carrierName"
      noLabel
      noErrorSection
      value={item?.carrierName || ""}
      setFieldValue={(_, value) => {
        handleTableUpdate(value);
      }}
      error={""}
    />
  );
}
